const RequiredLabel = ({ children }) => (
  <>
    {children}
    <span style={{ color: "red" }} aria-hidden="true"> *</span>
  </>
);


export default RequiredLabel;